import React from 'react';

function Vision() {
  return (
    <section id="vision">
      <div className="vision-label reveal">The Vision</div>
      <p className="vision-text reveal d1">
        Music from Chennai and the rest of India has always been held to standards that weren't ours to begin with. <b>We're here to change that.</b> Not by following trends, <b>but by creating them.</b> The goal is simple: make music so good that where it's from becomes irrelevant. What matters is the soul.
      </p>
    </section>
  );
}

export default Vision;
